import axios from "axios";
import { errorActions } from "../helpers/auth_helper";
import {
  IDesignAgentBotMetrics,
  IDesignAgentDashboardFilters,
  IDesignAgentSessionDetail,
  IDesignAgentSessionListResponse,
  IRatedMessage,
} from "../interfaces/design_agent_dashboard.interface";

const BASE = `${process.env.REACT_APP_API_URL}/design-agent/dashboard`;

export async function getDesignAgentBotMetrics(params?: {
  date_from?: string;
  date_to?: string;
  mode?: string;
  channel?: string;
}): Promise<IDesignAgentBotMetrics | undefined> {
  try {
    return await axios
      .get(`${BASE}/metrics/`, { params })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching design agent metrics");
      });
  } catch {}
}

export async function getDesignAgentDashboardSessions(
  filters: IDesignAgentDashboardFilters
): Promise<IDesignAgentSessionListResponse | undefined> {
  try {
    const params: Record<string, any> = { page: filters.page };
    if (filters.mode) params.mode = filters.mode;
    if (filters.channel) params.channel = filters.channel;
    if (filters.status) params.status = filters.status;
    if (filters.has_review) params.has_review = filters.has_review;
    if (filters.date_from) params.date_from = filters.date_from;
    if (filters.date_to) params.date_to = filters.date_to;
    if (filters.search) params.search = filters.search;
    if (filters.rating_lt != null) params.rating_lt = filters.rating_lt;
    if (filters.flagged) params.flagged = "true";
    if (filters.session_rating_lt != null)
      params.session_rating_lt = filters.session_rating_lt;
    if (filters.classification) params.classification = filters.classification;
    return await axios
      .get(`${BASE}/sessions/`, { params })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching design agent sessions");
      });
  } catch {}
}

export async function getDesignAgentSessionDetail(
  sessionId: number
): Promise<IDesignAgentSessionDetail | undefined> {
  try {
    return await axios
      .get(`${BASE}/sessions/${sessionId}/`)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching session detail");
      });
  } catch {}
}

export async function getRatedMessages(params?: {
  date_from?: string;
  date_to?: string;
  mode?: string;
  channel?: string;
}): Promise<IRatedMessage[] | undefined> {
  try {
    return await axios
      .get(`${BASE}/rated-messages/`, { params })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching rated messages");
      });
  } catch {}
}

export async function submitMessageReview(
  messageId: number,
  payload: { rating: number; remarks: string }
): Promise<{ status: string; rating: number } | undefined> {
  try {
    return await axios
      .post(`${BASE}/messages/${messageId}/review/`, payload)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error submitting message review");
      });
  } catch {}
}

export async function submitSessionReview(
  sessionId: number,
  payload: { rating?: number; remarks?: string }
): Promise<{ status: string; rating: number; human_reviewed: boolean } | undefined> {
  try {
    return await axios
      .post(`${BASE}/sessions/${sessionId}/review/`, payload)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error submitting session review");
      });
  } catch {}
}

export async function humanTakeover(
  contactPhone: string
): Promise<{ status: string; closed_sessions: number } | undefined> {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/design-agent/human-takeover/`, {
        contact_phone: contactPhone,
      })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error stopping bot for takeover");
      });
  } catch {}
}

export async function getBotStatus(): Promise<{ bot_enabled: boolean } | undefined> {
  try {
    return await axios
      .get(`${BASE}/bot-status/`)
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error fetching bot status");
      });
  } catch {}
}

export async function setBotStatus(
  enabled: boolean
): Promise<{ bot_enabled: boolean } | undefined> {
  try {
    return await axios
      .post(`${BASE}/bot-status/`, { enabled })
      .then((res) => res?.data)
      .catch((error) => {
        errorActions(error, "Error updating bot status");
      });
  } catch {}
}
